module.exports = __webpack_public_path__ + "img/glitter_11.45a82759.jpg";